import API from "../../../../../app/api";

export const getBlogDetails = async (slug) => {
  try {
    const res = await API.get(`/blogs/${slug}`);
    if (res.data.status === 200) {
      return res.data.data;
    }
    throw new Error(res.data.message || "Failed to fetch blog");
  } catch (err) {
    console.error("Error fetching blog:", err);
    throw err;
  }
};
